import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import store from './store'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import morrisonsTheme from './morrisons_theme'
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Routes from './routes'
import './morrisons.css'
import './print.css'
import './flex.css'
import injectTapEventPlugin from 'react-tap-event-plugin';
import ReactGA from 'react-ga'
import config from './config'

ReactGA.initialize(config.ga_ua, { debug: config.ga_debug })

injectTapEventPlugin({
	shouldRejectClick: function (lastTouchEventTimestamp, clickEventTimestamp) {
		if(lastTouchEventTimestamp) return true;
	}
});

let Root =
    <MuiThemeProvider muiTheme={getMuiTheme(morrisonsTheme)} >
        <Provider store={store}>
            <Routes/>
        </Provider>
    </MuiThemeProvider>

ReactDOM.render(Root, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js